import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useLanguage } from "../language/LanguageConfig.jsx";

const Shell = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Footer = styled.footer`
  border-top: 2px solid #e27361;
  background: #151a22;
  color: #fff;
  padding: ${(props) => (props.$home ? "54px 0 34px" : "44px 0 30px")};
`;

const FooterInner = styled(Shell)`
  text-align: center;
`;

const FooterCta = styled.div`
  display: ${(props) => (props.$home ? "block" : "none")};
`;

const FooterTitle = styled.h2`
  margin: 0 0 22px;
  font-size: 30px;
  line-height: 1.4;
  font-weight: 400;

  strong {
    font-weight: 900;
  }
`;

const FooterLead = styled.p`
  margin: 0 0 42px;
  color: #8d96a6;
  font-weight: 600;
`;

const FooterInfo = styled.div`
  border-top: 1px solid #2a303a;
  border-bottom: 1px solid #2a303a;
  padding: ${(props) => (props.$home ? "28px 0" : "30px 0 40px")};
  display: grid;
  grid-template-columns: minmax(210px, 1.1fr) minmax(310px, 1.55fr) minmax(170px, 1fr) minmax(220px, 1fr);
  column-gap: 52px;
  row-gap: 30px;
  text-align: left;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

const FirmName = styled.h3`
  margin: 0 0 14px;
  color: #fff;
  font-size: 21px;
  font-weight: 900;
`;

const InfoLabel = styled.p`
  margin: 0 0 10px;
  color: #e27361;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
`;

const InfoText = styled.p`
  margin: 0;
  color: #b0b7c3;
  line-height: 1.75;
  font-weight: 600;
`;

const FooterBottom = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: center;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Copyright = styled.p`
  margin: 0;
  color: #6f7784;
  text-align: left;
  font-size: 13px;
`;

const LegalLinks = styled.div`
  display: flex;
  gap: 28px;
`;

const LegalLink = styled.a`
  color: #7a828f;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    color: #fff;
  }
`;

const TechSiteFooter = ({ context: propContext, home: propHome }) => {
  const { pathname } = useLocation();
  const { dictionary } = useLanguage();
  const context = propContext || dictionary.techHomePage;
  const normalizedPath = pathname.replace(/\/$/, "");
  const isHome =
    typeof propHome === "boolean"
      ? propHome
      : /^\/[^/]+$/.test(normalizedPath) || /\/tech-home$/.test(normalizedPath);

  return (
    <Footer $home={isHome}>
      <FooterInner>
        <FooterCta $home={isHome}>
          {context.footerTitle ? <FooterTitle>{context.footerTitle}</FooterTitle> : null}
          {context.footerLead ? <FooterLead>{context.footerLead}</FooterLead> : null}
        </FooterCta>

        <FooterInfo $home={isHome}>
          <div>
            <FirmName>{context.firmName}</FirmName>
            <InfoText>WEthePEOPLE Law Group</InfoText>
          </div>
          <div>
            <InfoLabel>ADDRESS</InfoLabel>
            <InfoText>{context.address}</InfoText>
          </div>
          <div>
            <InfoLabel>TEL</InfoLabel>
            <InfoText>{context.tel}</InfoText>
          </div>
          <div>
            <InfoLabel>EMAIL</InfoLabel>
            <InfoText>{context.email}</InfoText>
          </div>
        </FooterInfo>

        <FooterBottom>
          <Copyright>&copy; 2026 WEthePEOPLE Law Group. All rights reserved.</Copyright>
    
        </FooterBottom>
      </FooterInner>
    </Footer>
  );
};

export default TechSiteFooter;
